import React from "react";
import { useAuth } from "@/context/AuthContext";
import { SettingsShell } from "./SettingsShell";

export default function ProfileSettings() {
    const { user } = useAuth();
    const extraTabs = user?.is_super_admin ? [{ to: "/app/settings/software-branding", label: "Software Branding" }] : [];
    return (
        <SettingsShell title="Profile" subtitle="Your personal account details." extraTabs={extraTabs}>
            <div className="max-w-2xl border border-border p-6 space-y-4" data-testid="profile-panel">
                <div className="grid md:grid-cols-2 gap-6">
                    <div>
                        <div className="overline">First name</div>
                        <div className="mt-2 text-sm">{user?.first_name}</div>
                    </div>
                    <div>
                        <div className="overline">Last name</div>
                        <div className="mt-2 text-sm">{user?.last_name}</div>
                    </div>
                </div>
                <div className="border-t border-border pt-4">
                    <div className="overline">Email</div>
                    <div className="mt-2 text-sm">{user?.email}</div>
                </div>
                <div className="border-t border-border pt-4">
                    <div className="overline">Role</div>
                    <div className="mt-2 text-sm">{user?.is_super_admin ? "Platform Super Admin" : "Organization Member"}</div>
                </div>
                <div className="border-t border-border pt-4 text-xs text-muted-foreground">
                    Profile editing (avatar upload, password change) ships in Release 2.
                </div>
            </div>
        </SettingsShell>
    );
}
